/* MUST HAVE NO DEPENDENCIES */

/*
  Global HLS.js Loader + Config Presets
  Loads hls.js only when needed.
  Provides preset configs for different video contexts.

  Usage:
    loadHLS().then(() => { // Hls is ready on window.Hls })
    getHLSConfig('multi')   → homepage with 4-5 videos
    getHLSConfig('single')  → product page with 1-2 videos
*/
(function () {
  var hlsPromise = null;

  var presets = {
    // Homepage: 4-5 looping background videos, lazy-loaded on scroll
    // 1-2 active at a time due to lazy loading
    multi: {
      startLevel: -1,
      testBandwidth: false,
      abrEwmaDefaultEstimate: 4000000,   // 4Mbps — assume decent connection, 1-2 active at a time
      abrEwmaFastLive: 3,                // fast reaction to bandwidth changes
      abrEwmaSlowLive: 9,
      abrEwmaFastVoD: 3,
      abrEwmaSlowVoD: 9,
      abrBandWidthUpFactor: 0.85,        // aggressive upgrade — prioritize crisp quality
      abrBandWidthFactor: 0.8,           // but drop fast if bandwidth can't keep up
      capLevelToPlayerSize: true,        // no point serving 4K to a 1080p container
      maxBufferLength: 15,               // buffer 15s ahead
      maxMaxBufferLength: 20,
      maxBufferSize: 25000000,           // 25MB per video
      backBufferLength: -1,              // keep everything — videos loop, no re-downloading
      enableWorker: true,                // off main thread for smooth parallax scrolling
      lowLatencyMode: false,
      progressive: true,
      startFragPrefetch: true
    },
    // Product pages: 1-2 looping background videos, full bandwidth available
    single: {
      startLevel: -1,
      testBandwidth: false,
      abrEwmaDefaultEstimate: 5000000,   // 5Mbps — full bandwidth for 1-2 videos
      abrEwmaFastLive: 3,
      abrEwmaSlowLive: 9,
      abrEwmaFastVoD: 3,
      abrEwmaSlowVoD: 9,
      abrBandWidthUpFactor: 0.9,         // very aggressive upgrade — quality is priority
      abrBandWidthFactor: 0.8,           // drop fast on slow connections
      capLevelToPlayerSize: true,        // match quality to actual rendered size
      maxBufferLength: 20,               // 20s ahead — more headroom with fewer videos
      maxMaxBufferLength: 30,
      maxBufferSize: 40000000,           // 40MB
      backBufferLength: -1,              // keep everything — videos loop
      enableWorker: true,
      lowLatencyMode: false,
      progressive: true,
      startFragPrefetch: true
    }
  };

  function loadHLS() {
    if (window.Hls) return Promise.resolve();
    if (hlsPromise) return hlsPromise;

    hlsPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = "//www.codeage.com/cdn/shop/t/442/assets/hls.min.js?v=47183760669960975531787116052";
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject(new Error('Failed to load hls.js'));
      };
      document.head.appendChild(script);
    });

    return hlsPromise;
  }

  function getHLSConfig(preset) {
    return Object.assign({}, presets[preset] || presets.multi);
  }

  window.loadHLS = loadHLS;
  window.getHLSConfig = getHLSConfig;
})();


/*
  switch videos for mobile and desktop
  responsive video script with HLS (m3u8) support + mp4 fallback
  Requires: global-hls-loader.js loaded before this script
*/
function initResponsiveVideos() {
  var videos = document.querySelectorAll('.js-responsive-video');

  var windowSize = innerWidth;
  var mobileBreakpoint = 768;
  var isMobile = windowSize <= mobileBreakpoint;

  videos.forEach(function (video) {
    var selectedSrc = isMobile ? video.dataset.mobileSrc : video.dataset.src;
    var fallbackSrc = isMobile ? video.dataset.mobileSrcFallback : video.dataset.srcFallback;
    var isHLS = selectedSrc && /\.m3u8(?:[?#]|$)/i.test(selectedSrc);

    // Set poster and dimensions
    if (isMobile) {
      if (video.dataset.mobilePoster) {
        video.setAttribute('poster', video.dataset.mobilePoster);
      }
      if (video.dataset.mobileHeight) {
        video.setAttribute('height', video.dataset.mobileHeight);
      }
      if (video.dataset.mobileWidth) {
        video.setAttribute('width', video.dataset.mobileWidth);
      }
    } else {
      if (video.dataset.desktopPoster) {
        video.setAttribute('poster', video.dataset.desktopPoster);
      }
    }

    if (isHLS) {

      /*
      // Native HLS (Safari / iOS)
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = selectedSrc;
        video.load();
        return;
      }
      */

      // hls.js first for consistent quality on all browsers
      if (typeof loadHLS === 'function') {
        loadHLS()
          .then(function () {
            if (window.Hls && Hls.isSupported()) {
              var preset = video.dataset.hlsPreset || 'multi';
              var hlsConfig = typeof getHLSConfig === 'function'
                ? getHLSConfig(preset)
                : {};
              var hls = new Hls(hlsConfig);
              hls.on(Hls.Events.MANIFEST_PARSED, function (_event, data) {
                hls.startLevel = data.levels.length - 1;
              });
              hls.loadSource(selectedSrc);
              hls.attachMedia(video);
              hls.on(Hls.Events.ERROR, function (_event, data) {
                if (data.fatal) {
                  switch (data.type) {
                    case Hls.ErrorTypes.NETWORK_ERROR:
                      hls.startLoad();
                      break;
                    case Hls.ErrorTypes.MEDIA_ERROR:
                      hls.recoverMediaError();
                      break;
                    default:
                      hls.destroy();
                      // HLS completely failed — use mp4 fallback
                      appendFallback(video, fallbackSrc);
                      break;
                  }
                }
              });
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
              // Native fallback (Safari if hls.js somehow unsupported)
              video.src = selectedSrc;
              video.load();
            } else {
              appendFallback(video, fallbackSrc);
            }
          })
          .catch(function () {
            // hls.js failed to load — use mp4 fallback
            appendFallback(video, fallbackSrc);
          });
      } else {
        // Global loader not available — use mp4 fallback
        appendFallback(video, fallbackSrc);
      }
    } else {
      // Standard mp4 / webm
      appendFallback(video, selectedSrc);
    }
  });
}

function appendFallback(video, src) {
  if (!src) return;
  var source = document.createElement('source');
  source.setAttribute('type', 'video/mp4');
  source.setAttribute('src', src);
  video.appendChild(source);
  video.load();
}


/* 
  RUN THIS CODE BEFORE PARALLAX ON RECENTLY VIEWED PRODUCTS 
  CHANGE THE OFFSET OF MOBILE TO MAKE IT RUN SMOOTHER
*/
function fixMobileOffsetForJarallaxElement(){
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const mobileOffset = '90 0';
  document.querySelectorAll('.js-recently-viewed-split-container[data-jarallax-element]').forEach((item) =>{
    if(isMobile){
      item.setAttribute('data-jarallax-element', mobileOffset);
    }
  })
}





document.addEventListener("responsive-video", initResponsiveVideos);

fixMobileOffsetForJarallaxElement()
initResponsiveVideos();